<div>
  <mat-dialog-content class="mat-typography">
    <ng-container *ngIf="salesOrdersWithExistingPicklists?.length > 0">
      <div class="mb-5">
        <h2 mat-dialog-title>Existing Picklists</h2>
        <mat-chip-list #chipList>
          <mat-chip
            style="cursor: pointer"
            *ngFor="
              let salesOrderId of salesOrdersWithExistingPicklists;
              trackBy: trackByValue
            "
            (click)="onRedirectToSalesOrderPicklist(salesOrderId)"
          >
            {{ salesOrderId }}
          </mat-chip>
        </mat-chip-list>
      </div>
    </ng-container>

    <ng-container *ngIf="salesOrdersWithMoreThanOneShipment?.length > 0">
      <div class="mb-5">
        <h2 mat-dialog-title>Multiple Shipments</h2>
        <mat-chip-list #chipList>
          <mat-chip
            style="cursor: pointer"
            *ngFor="
              let salesOrderId of salesOrdersWithMoreThanOneShipment;
              trackBy: trackByValue
            "
            (click)="onRedirectToSalesOrderPicklist(salesOrderId)"
          >
            {{ salesOrderId }}
          </mat-chip>
        </mat-chip-list>
      </div>
    </ng-container>

    <ng-container *ngIf="picklistPreviewItems.length > 0">
      <h2 mat-dialog-title>Unable to Fulfill Orders</h2>
      <lum-picklist-preview-table
        [items]="picklistPreviewItems"
      ></lum-picklist-preview-table>
    </ng-container>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <ng-container *ngIf="!hideActionButtons">
      <button
        mat-button
        class="lum-button lum-button--secondary lum-button--medium"
        (click)="closeDialog()"
      >
        No
      </button>
      <button
        mat-button
        class="lum-button lum-button lum-button--medium"
        (click)="continueCreatePicklist()"
      >
        Continue with Fulfillable Orders
      </button>
    </ng-container>
    <button
      *ngIf="hideActionButtons"
      mat-button
      class="lum-button lum-button--secondary lum-button--medium"
      (click)="closeDialog()"
    >
      Close
    </button>
  </mat-dialog-actions>
</div>
